import React from 'react';
import { useState } from 'react';
import CardQuestion from './cardQuestions';
import { makeStyles } from '@material-ui/styles';


const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        minHeight:270,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
        flexDirection:'column',
        margin:'auto 0px',
        marginTop:3,

    },
  
}))


const BoxAnswer = ({ data, indexQuestion, setAnswerQuestion }) => {

    const classes = useStyles();

    const [Click, setClick] = useState(null);

    return (
        <>
        {/* className="w-full flex justify-center items-center flex-col mx-auto mt-3 min-h-[270px]" */}
            <div className={classes['root']} >
                {
                    data[indexQuestion]
                        ? (
                            data[indexQuestion]?.Option.map((item, ind) => (
                                <CardQuestion
                                    key={ind}
                                    ind={ind}
                                    data={item}
                                    indexQuestion={indexQuestion}
                                    setAnswerQuestion={setAnswerQuestion}
                                    Click={Click}
                                    setClick={setClick}
                                    question={data[indexQuestion]}
                                />
                            ))
                        )
                        : ''
                }

            </div>
        </>
    );
}

export default BoxAnswer;
